module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-success"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_vm._l((_vm.dataObj.food), function(f, i) {
    return [_c('item', {
      attrs: {
        "data-index": i,
        "data-item": f,
        "data-ref": _vm.dataRef
      },
      on: {
        "removeItem": _vm.removeItem
      }
    })]
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success center-block",
    attrs: {
      "type": "button",
      "title": "Add item"
    },
    on: {
      "click": _vm.addNew
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  })])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_c('h3', [_vm._v("Food Consumption")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16cc6859!./~/vue-loader/lib/selector.js?type=template&index=0!./src/food.vue
// module id = 141
// module chunks = 0